"use client";

import { useEffect } from "react";

/**
 * Un retour arrière du navigateur vers cette page peut aboutir à une requête
 * serveur qui repart sans les cookies (observé empiriquement : `persisted`
 * de l'event `pageshow` reste à `false`, donc pas un bfcache "classique",
 * mais le résultat est le même — la page rendue ne reflète pas la session
 * réelle). La Navigation Timing API donne un signal fiable pour ce cas :
 * `type === "back_forward"` sur l'entrée de navigation identifie une
 * page atteinte via retour/avance, qu'elle vienne du bfcache ou non. On
 * force alors un rechargement, qui repart en type "reload" (jamais
 * "back_forward"), donc sans risque de boucle.
 */
export function BfcacheReloadGuard() {
  useEffect(() => {
    const [nav] = performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    if (nav?.type === "back_forward") {
      window.location.reload();
      return;
    }

    function onPageShow(e: PageTransitionEvent) {
      if (e.persisted) window.location.reload();
    }
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, []);

  return null;
}
